/*
 * Copyright (c) 2025 Amazon.com
 * This file is licensed under the MIT License.
 * See the LICENSE file in the project root for full license information.
 */
import { useContext, createContext } from 'react';

export const CallsContext = createContext(null);

const useCallsContext = () => useContext(CallsContext);

export default useCallsContext;
